// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import moment from 'moment';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class AdminContentModuleListItem extends Base {
  constructor(props, context) {
    super(props);
  }

  _goToItemShow(contentModuleId) {
    this.props.history.push(`/admin/authoring/content-modules/${contentModuleId}`);
  }

  render() {
    const { contentModule } = this.props;
    return (
      <tr className="linkable" onClick={this._goToItemShow.bind(this, contentModule._id)}>
        <td className="_30">{contentModule.title}</td>
        <td className="_50 ellipsis">{contentModule.summary}</td>
        <td className="_20">{moment(contentModule.updated).format("MMMM Do YYYY, h:mm a")}</td>
      </tr>
    )
  }
}

AdminContentModuleListItem.propTypes = {
  contentModule: PropTypes.object.isRequired
}

export default withRouter(AdminContentModuleListItem);



// WEBPACK FOOTER //
// modules/contentModule/components/AdminContentModuleListItem.js.jsx